/** The top of a section: its name, one line on what it is for, and the section's main actions. */
const PageHeader = ({ title, description, actions }) => {
  return (
    <header className="comp-page__header">
      <div>
        <h1 className="comp-page__title">{title}</h1>
        {description && <p className="comp-page__description">{description}</p>}
      </div>
      {actions && <div className="comp-page__actions">{actions}</div>}
    </header>
  );
};

export default PageHeader;
